import { render, staticRenderFns } from "./WorkflowTestTaskDetail.vue?vue&type=template&id=9840c95c"
import script from "./WorkflowTestTaskDetail.vue?vue&type=script&lang=js"
export * from "./WorkflowTestTaskDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports